export const navbarLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
  { name: "Github", path: "" },
];

export const appTitle = "Meditation App";
export const bannerText =
  "Welcome to the Meditation App! Find your peace and calm.";
export const bannerAltText = "Meditation Banner";

export const bannerButton = "Get started";
export const submitButton = "Submit";

export const contactButtonSubmitText = "Submit";

export const contactBodyTitle =
  "If you have any questions, feel free to reach out!";

export const contactBodyText =
  "We would love to hear from you. Please fill out the form below to get in touch with us.";

export const nameText = "Name:";
export const emailText = "Email:";

export const aboutBodyText = "This is the about page of our meditation app.";
export const aboutTitle = "About Us";

export const signupButtonText = "Sign Up";

export const memberText = "Already a member?";

export const loginText = "Log In";

export const noMemberText = "Not a member?";

export const herosectionText = [
  {
    headline: "What's on your mind?",
    subheadline: "Join us on a journey to mindfulness and tranquility.",
    title: "Click here! Share your mood with us! Let's go...",
  },
];
